var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 42,
    viewBox: "0 0 156 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5239 28.8408L66.1939 21.4308H53.1439L49.8139 28.8408H45.6739L56.4739 5.53082H62.8939L73.6939 28.8408H69.5239ZM59.1739 8.08082L54.3139 18.8808H65.0539L60.2239 8.08082H59.1739ZM75.1828 8.41082V5.53082H78.7828V8.41082H75.1828ZM75.1828 28.8408V12.1908H78.7828V28.8408H75.1828ZM99.417 12.1908L91.647 28.8408H87.717L79.977 12.1908H84.117L89.697 25.6308L95.337 12.1908H99.417ZM99.716 20.5008C99.716 15.6108 103.226 11.7708 109.166 11.7708C115.106 11.7708 118.616 15.6108 118.616 20.5008C118.616 25.4208 115.106 29.2608 109.166 29.2608C103.226 29.2608 99.716 25.4208 99.716 20.5008ZM103.556 20.5008C103.556 24.1008 105.686 26.5908 109.166 26.5908C112.586 26.5908 114.776 24.1008 114.776 20.5008C114.776 16.9008 112.586 14.4408 109.166 14.4408C105.686 14.4408 103.556 16.9008 103.556 20.5008ZM124.916 18.9708V28.8408H121.316V12.1908H123.056L124.586 17.1408C124.586 17.1408 125.156 11.7708 129.746 11.7708C132.506 11.7708 133.376 13.6608 133.376 15.8508C133.376 17.9808 132.776 19.3908 132.776 19.3908L129.056 20.4708C129.056 20.4708 129.686 18.5508 129.686 16.6308C129.686 15.1908 129.206 14.4408 128.216 14.4408C125.906 14.4408 124.916 18.0108 124.916 18.9708ZM149.118 24.8508C149.088 25.9008 149.478 26.5908 150.438 26.5908C151.908 26.5908 152.568 25.0908 152.568 25.0908L153.288 27.7608C153.288 27.7608 152.178 29.2608 149.388 29.2608C147.528 29.2608 145.668 28.3308 145.668 25.3908V22.5408C145.668 22.5408 143.268 29.2608 138.288 29.2608C135.828 29.2608 134.268 27.6708 134.268 25.6008C134.268 22.8108 136.728 18.9408 145.668 17.9208C145.668 17.9208 145.968 14.4408 142.098 14.4408C138.198 14.4408 137.388 17.8008 137.388 17.8008L133.668 16.7208C133.668 16.7208 135.288 11.7708 141.978 11.7708C146.958 11.7708 149.388 14.4408 149.298 17.8608L149.118 24.8508ZM138.078 24.8508C138.078 25.9908 138.678 26.5908 139.668 26.5908C142.848 26.5908 145.728 21.2508 145.668 19.9908V18.9408C138.978 20.6508 138.078 23.3808 138.078 24.8508Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1683_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3948 32.7578L5.54366 32.6833C4.88797 32.6833 4.87306 32.0872 5.24561 31.7892C6.10337 30.3487 7.95957 27.5359 8.16606 27.1783C8.37255 26.8206 8.55014 26.7312 8.61313 26.7312H18.4485C18.8658 26.7312 19.1191 26.4332 19.1936 26.2841C19.6043 25.5887 20.4774 24.1084 20.6839 23.7508C20.8903 23.3931 21.1673 23.3037 21.2799 23.3037H32.3702C33.324 23.3037 33.2644 23.8998 33.1153 24.1978C32.2709 25.6952 30.478 29.0941 29.5243 30.746C28.6639 32.2363 27.2145 32.8323 26.3948 32.7578Z",
    fill: "#2C32FE",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3948 32.7578L5.54366 32.6833C4.88797 32.6833 4.87306 32.0872 5.24561 31.7892C6.10337 30.3487 7.95957 27.5359 8.16606 27.1783C8.37255 26.8206 8.55014 26.7312 8.61313 26.7312H18.4485C18.8658 26.7312 19.1191 26.4332 19.1936 26.2841C19.6043 25.5887 20.4774 24.1084 20.6839 23.7508C20.8903 23.3931 21.1673 23.3037 21.2799 23.3037H32.3702C33.324 23.3037 33.2644 23.8998 33.1153 24.1978C32.2709 25.6952 30.478 29.0941 29.5243 30.746C28.6639 32.2363 27.2145 32.8323 26.3948 32.7578Z",
    stroke: "url(#paint0_linear_1683_2936)",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1683_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1112 32.5436H5.48359C4.82789 32.5436 5.01169 32.0469 5.18555 31.7985C6.04331 30.358 7.81046 27.3875 8.01695 27.0298C8.22344 26.6722 8.40103 26.5828 8.46401 26.5828H18.2994C18.7167 26.5828 18.97 26.2847 19.0445 26.1357C19.4552 25.4403 20.3282 23.96 20.5347 23.6023C20.7412 23.2447 21.0182 23.1553 21.1308 23.1553H32.2211C33.1749 23.1553 33.1152 23.7514 32.9662 24.0494C32.1218 25.5467 30.1944 28.9544 29.2407 30.6063C28.287 32.2583 27.0653 32.5436 26.1112 32.5436Z",
    fill: "#2C32FE",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1112 32.5436H5.48359C4.82789 32.5436 5.01169 32.0469 5.18555 31.7985C6.04331 30.358 7.81046 27.3875 8.01695 27.0298C8.22344 26.6722 8.40103 26.5828 8.46401 26.5828H18.2994C18.7167 26.5828 18.97 26.2847 19.0445 26.1357C19.4552 25.4403 20.3282 23.96 20.5347 23.6023C20.7412 23.2447 21.0182 23.1553 21.1308 23.1553H32.2211C33.1749 23.1553 33.1152 23.7514 32.9662 24.0494C32.1218 25.5467 30.1944 28.9544 29.2407 30.6063C28.287 32.2583 27.0653 32.5436 26.1112 32.5436Z",
    stroke: "url(#paint1_linear_1683_2936)",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1683_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7896 21.8956H7.42083C6.70552 21.9552 6.82474 21.523 6.97376 21.2995C7.78185 19.8093 9.44966 16.7394 9.65615 16.3818C9.86264 16.0241 10.0402 15.9347 10.1032 15.9347H16.5111C16.8688 15.9347 17.0575 15.736 17.1072 15.6367C17.5179 14.9412 18.3909 13.461 18.5974 13.1033C18.8039 12.7457 18.9815 12.6562 19.0445 12.6562H34.1584C34.8737 12.6562 34.7544 13.1886 34.6054 13.4548C33.6368 15.1259 31.6846 18.4979 31.625 18.6171C31.5654 18.7363 31.4015 18.7661 31.327 18.7661H22.919C22.5018 18.7661 22.3478 18.8655 22.323 18.9151C21.9906 19.5112 21.2571 20.8226 20.9818 21.2995C20.7064 21.7763 20.3703 21.8956 20.2367 21.8956H19.7896Z",
    fill: "#00A4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7896 21.8956H7.42083C6.70552 21.9552 6.82474 21.523 6.97376 21.2995C7.78185 19.8093 9.44966 16.7394 9.65615 16.3818C9.86264 16.0241 10.0402 15.9347 10.1032 15.9347H16.5111C16.8688 15.9347 17.0575 15.736 17.1072 15.6367C17.5179 14.9412 18.3909 13.461 18.5974 13.1033C18.8039 12.7457 18.9815 12.6562 19.0445 12.6562H34.1584C34.8737 12.6562 34.7544 13.1886 34.6054 13.4548C33.6368 15.1259 31.6846 18.4979 31.625 18.6171C31.5654 18.7363 31.4015 18.7661 31.327 18.7661H22.919C22.5018 18.7661 22.3478 18.8655 22.323 18.9151C21.9906 19.5112 21.2571 20.8226 20.9818 21.2995C20.7064 21.7763 20.3703 21.8956 20.2367 21.8956H19.7896Z",
    stroke: "#00020F",
    strokeWidth: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1683_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9386 22.045H7.56987C6.85457 22.1046 6.97379 21.6724 7.12281 21.4489C7.9309 19.9587 9.5987 16.8888 9.80519 16.5312C10.0117 16.1735 10.1893 16.0841 10.2523 16.0841H16.6602C17.0178 16.0841 17.2066 15.8854 17.2563 15.7861C17.667 15.0907 18.54 13.6104 18.7465 13.2527C18.953 12.8951 19.1305 12.8057 19.1935 12.8057H34.3074C35.0227 12.8057 34.9035 13.3381 34.7545 13.6043C33.7858 15.2753 31.8337 18.6473 31.774 18.7665C31.7144 18.8857 31.5505 18.9155 31.476 18.9155H23.0681C22.6508 18.9155 22.4968 19.0149 22.472 19.0645C22.1397 19.6606 21.4061 20.972 21.1308 21.4489C20.8555 21.9258 20.5194 22.045 20.3857 22.045H19.9386Z",
    fill: "#00A4AF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9386 22.045H7.56987C6.85457 22.1046 6.97379 21.6724 7.12281 21.4489C7.9309 19.9587 9.5987 16.8888 9.80519 16.5312C10.0117 16.1735 10.1893 16.0841 10.2523 16.0841H16.6602C17.0178 16.0841 17.2066 15.8854 17.2563 15.7861C17.667 15.0907 18.54 13.6104 18.7465 13.2527C18.953 12.8951 19.1305 12.8057 19.1935 12.8057H34.3074C35.0227 12.8057 34.9035 13.3381 34.7545 13.6043C33.7858 15.2753 31.8337 18.6473 31.774 18.7665C31.7144 18.8857 31.5505 18.9155 31.476 18.9155H23.0681C22.6508 18.9155 22.4968 19.0149 22.472 19.0645C22.1397 19.6606 21.4061 20.972 21.1308 21.4489C20.8555 21.9258 20.5194 22.045 20.3857 22.045H19.9386Z",
    stroke: "url(#paint2_linear_1683_2936)",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1683_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7896 21.8956H7.42083C6.70552 21.9552 6.82474 21.523 6.97376 21.2995C7.78185 19.8093 9.44966 16.7394 9.65615 16.3818C9.86264 16.0241 10.0402 15.9347 10.1032 15.9347H16.5111C16.8688 15.9347 17.0575 15.736 17.1072 15.6367C17.5179 14.9412 18.3909 13.461 18.5974 13.1033C18.8039 12.7457 18.9815 12.6562 19.0445 12.6562H34.1584C34.8737 12.6562 34.7544 13.1886 34.6054 13.4548C33.6368 15.1259 31.6846 18.4979 31.625 18.6171C31.5654 18.7363 31.4015 18.7661 31.327 18.7661H22.919C22.5018 18.7661 22.3478 18.8655 22.323 18.9151C21.9906 19.5112 21.2571 20.8226 20.9818 21.2995C20.7064 21.7763 20.3703 21.8956 20.2367 21.8956H19.7896Z",
    fill: "#00A4AF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7896 21.8956H7.42083C6.70552 21.9552 6.82474 21.523 6.97376 21.2995C7.78185 19.8093 9.44966 16.7394 9.65615 16.3818C9.86264 16.0241 10.0402 15.9347 10.1032 15.9347H16.5111C16.8688 15.9347 17.0575 15.736 17.1072 15.6367C17.5179 14.9412 18.3909 13.461 18.5974 13.1033C18.8039 12.7457 18.9815 12.6562 19.0445 12.6562H34.1584C34.8737 12.6562 34.7544 13.1886 34.6054 13.4548C33.6368 15.1259 31.6846 18.4979 31.625 18.6171C31.5654 18.7363 31.4015 18.7661 31.327 18.7661H22.919C22.5018 18.7661 22.3478 18.8655 22.323 18.9151C21.9906 19.5112 21.2571 20.8226 20.9818 21.2995C20.7064 21.7763 20.3703 21.8956 20.2367 21.8956H19.7896Z",
    stroke: "url(#paint3_linear_1683_2936)",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1683_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12007 11.3884H18.8809C19.3165 10.693 20.2009 9.22762 20.2967 9.00409C20.5202 8.48252 20.8794 8.40801 21.0418 8.40801H33.1752C33.5329 8.40801 33.7961 8.17084 33.8458 8.10999C34.6157 6.77641 36.2748 4.01824 36.7517 3.19229C37.2286 2.36633 36.3295 2.10299 35.8576 2.1491C30.6667 2.1491 17.8524 2.45586 16.0641 2.45586C14.2758 2.45586 12.9843 3.8035 12.5621 4.47732C11.4941 6.32712 9.17966 9.80032 8.82201 10.4198C8.46436 11.0393 8.84686 11.3982 9.12007 11.3884Z",
    fill: "#00FF97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12007 11.3884H18.8809C19.3165 10.693 20.2009 9.22762 20.2967 9.00409C20.5202 8.48252 20.8794 8.40801 21.0418 8.40801H33.1752C33.5329 8.40801 33.7961 8.17084 33.8458 8.10999C34.6157 6.77641 36.2748 4.01824 36.7517 3.19229C37.2286 2.36633 36.3295 2.10299 35.8576 2.1491C30.6667 2.1491 17.8524 2.45586 16.0641 2.45586C14.2758 2.45586 12.9843 3.8035 12.5621 4.47732C11.4941 6.32712 9.17966 9.80032 8.82201 10.4198C8.46436 11.0393 8.84686 11.3982 9.12007 11.3884Z",
    stroke: "url(#paint4_linear_1683_2936)",
    strokeWidth: 0.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1683_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13472 11.099H18.6721C19.1076 10.4036 20.0303 8.92332 20.2368 8.56567C20.4433 8.20802 20.8196 8.1186 20.9819 8.1186H33.0408C33.3985 8.1186 33.5873 7.99689 33.6369 7.93604L36.5428 2.90285C37.0197 2.07689 36.1951 1.96261 35.7232 2.00872H15.9152C14.1269 2.00872 12.8354 3.35636 12.4132 4.03018L8.76217 10.3539C8.40452 10.9734 8.86152 11.1088 9.13472 11.099Z",
    fill: "#00FF97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13472 11.099H18.6721C19.1076 10.4036 20.0303 8.92332 20.2368 8.56567C20.4433 8.20802 20.8196 8.1186 20.9819 8.1186H33.0408C33.3985 8.1186 33.5873 7.99689 33.6369 7.93604L36.5428 2.90285C37.0197 2.07689 36.1951 1.96261 35.7232 2.00872H15.9152C14.1269 2.00872 12.8354 3.35636 12.4132 4.03018L8.76217 10.3539C8.40452 10.9734 8.86152 11.1088 9.13472 11.099Z",
    stroke: "url(#paint5_linear_1683_2936)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1683_2936",
    x: -24.3502,
    y: 18.9537,
    width: 102.901,
    height: 84.1604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1683_2936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1683_2936",
    x: -24.328,
    y: 18.8053,
    width: 102.73,
    height: 84.0882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1683_2936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1683_2936",
    x: 0.610718,
    y: 10.4062,
    width: 42.3578,
    height: 23.7451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.0156863 0 0 0 0 0.0627451 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1683_2936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1683_2936",
    x: 2.75977,
    y: 12.5557,
    width: 36.3578,
    height: 17.7451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1683_2936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1683_2936",
    x: -0.389282,
    y: 9.40625,
    width: 42.3578,
    height: 23.7451,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1683_2936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1683_2936",
    x: -0.573242,
    y: 1.89404,
    width: 42.7104,
    height: 23.7446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0117647 0 0 0 0 0.0196078 0 0 0 0 0.0666667 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1683_2936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1683_2936",
    x: 2.68086,
    y: -5.95,
    width: 39.9555,
    height: 20.9996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.0156863 0 0 0 0 0.0431373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_2936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1683_2936",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1683_2936",
    x1: 9.3073,
    y1: 25.9185,
    x2: 23.2146,
    y2: 36.3181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35533,
    stopColor: "#2A2FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791662,
    stopColor: "#A3A6FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1683_2936",
    x1: 19.03,
    y1: 24.6368,
    x2: 21.121,
    y2: 29.9014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1683_2936",
    x1: 17.7633,
    y1: 13.6911,
    x2: 23.2736,
    y2: 21.6601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292FE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1683_2936",
    x1: 21.0417,
    y1: 20.2476,
    x2: 19.5653,
    y2: 14.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734077,
    stopColor: "white",
    stopOpacity: 0.734077
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1683_2936",
    x1: 11.4299,
    y1: 5.06378,
    x2: 25.1072,
    y2: 17.7626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193043,
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808479,
    stopColor: "#2C32FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1683_2936",
    x1: 12.8584,
    y1: 3.44208,
    x2: 24.065,
    y2: 15.6475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35533,
    stopColor: "#00FF97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791662,
    stopColor: "#BDFFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b701aa8c72fee4e8d4d7c222e5e96f1f.svg";
export { ForwardRef as ReactComponent };